// @flow
import React, { Component } from 'react'
import { Auth } from '../../services/auth'
import { LoadingContainer, LoadingIcon } from './style'
import { Spin, Modal, message } from 'antd'

type State = {
  auth: Auth
}

type Props = {
  visible: boolean,
  onHideModal: void => void
}

class LayoutLoading extends Component<Props, State> {

  state: State = {
    auth: new Auth()
  }

  // --- Modal ---
  // on Confirm
  handleOk = () => {

    // give feedback
    message.info('Launching Email')

    // open native email
    window.location.href = `mailto:support@optionsedu.com?subject=Request%20Beta%20Access&body=Please add this email to the beta platform, thank you.`

    // timeout then show lock
    setTimeout(() => this.handleClose(), 3000)
  }

  // on close
  handleClose = () => {

    const { onHideModal } = this.props
    const { auth: { showLock } } = this.state
    
    // reset & display lock
    onHideModal()
    showLock()
  }

  render() {

    // --- Props and State ---
    const { visible } = this.props

    // --- Request Access Modal ---
    const modal = (): Modal => {
      return (
        <Modal
          title='Request Access'
          visible={visible}
          okText={'Request'}
          onOk={this.handleOk}
          onCancel={this.handleClose}>

          <p>
            Click 'Request' or email operations@optionsedu.com
            to gain access to OptionsEDU Beta platform.
          </p>
        </Modal>
      )
    }

    // --- Loading Spinner ---
    const spinner = (): Spin => {
      return <Spin indicator={<LoadingIcon type='loading' spin />} />
    }

    return (
      <LoadingContainer>
        { visible ? modal() : spinner() }
      </LoadingContainer>
    )
  }
}

export default LayoutLoading



// WEBPACK FOOTER //
// ./src/components/layout-loading/index.js